import { useMemo, type ReactNode } from 'react'
import { IMAGE_RESOLUTIONS } from 'components/HomepageCarousel/Carousel/constants'
import { useSpringboardCarouselData } from '../hooks'
import { SpringboardCarouselTile } from './SpringboardCarouselTile'

const imageWidth = IMAGE_RESOLUTIONS.lg.width
const imageHeight = IMAGE_RESOLUTIONS.lg.height

const nameplateAnchorStyle = { transform: 'translateY(0%)' } // Ensures the nameplateImage is anchored to its tile
const brickStaggerStyle = { transform: 'translateY(-50%)' } // Creates the running bond brick/staggered layout effect

export const DoubleColumnSpringboardCarousel = () => {
  const carouselSpringboardItems = useSpringboardCarouselData()

  return useMemo(
    () =>
      [...carouselSpringboardItems, ...carouselSpringboardItems].reduce<
        ReactNode[]
      >((result, _, i, items) => {
        if (i % 2 === 0 && i + 1 < items.length) {
          const firstColumn = items[i]
          const secondColumn = items[i + 1]

          result.push(
            <div
              key={`${i}-${i + 1}`}
              className='mc-gap-3 mc-mb-3 d-flex justify-content-center'
              role='group'
            >
              <div style={nameplateAnchorStyle}>
                <SpringboardCarouselTile
                  uuid={firstColumn.uuid}
                  itemType={firstColumn.itemType}
                  imageURL={firstColumn.carouselImageURL}
                  height={imageHeight}
                  width={imageWidth}
                  title={firstColumn.title}
                  nameplateImage={firstColumn.nameplateImage}
                  showCategoryBadge={!!firstColumn.primaryCategory?.name}
                  category={firstColumn.primaryCategory?.name}
                  categoryId={firstColumn.primaryCategory?.id}
                  slug={firstColumn.slug}
                />
              </div>
              <div style={brickStaggerStyle}>
                <SpringboardCarouselTile
                  uuid={secondColumn.uuid}
                  itemType={secondColumn.itemType}
                  imageURL={secondColumn.carouselImageURL}
                  height={imageHeight}
                  width={imageWidth}
                  title={secondColumn.title}
                  nameplateImage={secondColumn.nameplateImage}
                  showCategoryBadge={!!secondColumn.primaryCategory?.name}
                  category={secondColumn.primaryCategory?.name}
                  categoryId={secondColumn.primaryCategory?.id}
                  slug={secondColumn.slug}
                />
              </div>
            </div>,
          )
        }
        return result
      }, []),
    [carouselSpringboardItems],
  )
}
